var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowPointing1 = function SvgArrowPointing1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193,
    height: 141,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB81C",
    strokeDasharray: "8 8",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M33.758 123.156c-.404-3.125-3.35-6.527-5.215-8.845-2.185-2.718-4.764-4.853-7.705-6.685-.706-.44-1.445-.859-2.12-1.348-.528-.383 1.397-.308 2.008-.539 5.092-.376 5.837-1.098 9.27-3.2 4.513-2.763 7.317-3.87 10.78-7.438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFB81C",
    strokeDasharray: "6 6",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M163.912 7.813c-2.51 18.245-14.512 34.862-26.973 47.652-18.013 18.49-39.542 33.31-63.011 44.03-8.58 3.92-19.536 7.471-29.162 8.688-7.784.984-6.718-.505-13.816-.477"
  })));
};
export default SvgArrowPointing1;